// extracted by mini-css-extract-plugin
export default {"Switch":"+rP4Xv-DnzdzykiNM6wKxQ==","disabled":"qEnbdL8G2-6-lFSltsA1SA=="};